module.exports = __webpack_public_path__ + "img/logo.f3f9502.png";